'use strict';

var _extends = require('../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var withStyles = require('../DesignSystem/Styles/withStyles.js');
var classNames = require('classnames');
var ExpandableTableCell = require('../DesignSystem/DataDisplay/Table/ExpandableTableCell.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  truncatedContainer: {
    overflow: 'hidden',
    columnWidth: 'auto',
    height: ExpandableTableCell.TWO_ROW_HEIGHT,
    columnCount: 1
  },
  expandedContainer: {
    height: '100%'
  }
};

var TruncateComponents = function TruncateComponents(_ref) {
  var classes = _ref.classes,
      _ref$wrapperComponent = _ref.wrapperComponent,
      Wrapper = _ref$wrapperComponent === void 0 ? 'div' : _ref$wrapperComponent,
      className = _ref.className,
      truncate = _ref.truncate,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["classes", "wrapperComponent", "className", "truncate", "children"]);

  return React__default["default"].createElement(Wrapper, _extends["default"]({
    className: classNames__default["default"](truncate ? classes.truncatedContainer : classes.expandedContainer, className)
  }, props), children);
};

TruncateComponents.defaultProps = {
  truncate: true
};
var TruncateComponents$1 = withStyles["default"](styles)(TruncateComponents);

module.exports = TruncateComponents$1;
